import {ApiResponseDto, VivoRootModel} from "@utils/Models";
import {getOneLoginUser} from "@utils/onelogin/OneLoginHelper";
import axios from "axios";
import {AuthenticationResponse} from "./auth.models";
import {ApiUrl_Login_ExchangeOneLoginToken, ApiUrl_Login_VerifyMember} from "@utils/Endpoints";
import {JwtUtils} from "./JwtUtils";
import {boolean} from "yup";

export default function useAuthenticationHelper() {
    /** checks if there is onelogin token. if not, returns null. Checks if the token is valid and obtains Vivo token along with RootModel.
     * saves the Vivo token and returns the root model */
    async function validateOneLoginUserAsync(): Promise<VivoRootModel | null> {
        const user = await getOneLoginUser();
        if (!user)
            return null;
        try {
            let response = await axios.post<ApiResponseDto<AuthenticationResponse>>(ApiUrl_Login_ExchangeOneLoginToken, user);
            let data = response.data.Result;
            JwtUtils.saveToken(data);
            return data.RootModel;
        } catch (error) {
            return null;
        }
    }

    /** tries to use saved token to authorize connection to vivo portal backend. if it works (token is valid), returns fresh root model.
     * if it doesn't work, returns null */
    async function validateUmbracoTokenAsync(): Promise<VivoRootModel | null> {
        try {
            let response = await axios.post<ApiResponseDto<VivoRootModel>>(ApiUrl_Login_VerifyMember);
            return response.data.Result;
        } catch (error) {
            return null;
        }
    }

    return {
        validation: {
            validateOneLoginUserAsync,
            validateUmbracoTokenAsync
        }
    }
}